

export const SIDEBAR_WIDTH = 250;
export const EXTENDED_SIDEBAR_WIDTH = 300;
